import { KsService } from '@siclop/kstone-vue'

export class ProfessionService extends KsService {
  protected static mainUrl = '/professions'
}
